import {ToastType} from "@/types/toast";
import {createContext, useContext, useState} from "react";
import { ToastOptionType, ToastComponentType } from '@/types/toast'
import { uniqueId } from 'lodash'
import ToastList from "@/components/ToastProvider/ToastList/ToastList";
type ToastContextType = [ToastType[], (toasts: ToastType[]) => void]

const initialState: ToastContextType = [[], () => {}]

const ToastContext = createContext<ToastContextType>(initialState)

const passState: { toasts: ToastType[], setToasts: (toasts: ToastType[]) => void} = {
  toasts: [],
  setToasts: () => console.error("setToasts function not yet initialized"),
};

type Props = {
  children: React.ReactNode
}

const ToastProvider = ({children}: Props) => {
  const [toasts, setToasts] = useState<ToastType[]>([])

  passState.setToasts = setToasts;
  passState.toasts = toasts;

  return <ToastContext.Provider value={[toasts, setToasts]}>
    <ToastList/>
    {children}
  </ToastContext.Provider>
}

export const useToasts = (): ToastContextType => useContext(ToastContext)
export default ToastProvider


const create = (
  content: any,
  title = 'Network Error',
  type: ToastOptionType = 'error',
  duration = 3000,
) => {
  if (typeof window === 'undefined') return

  let contentString = ''

  if (typeof content === 'string') contentString = content
  else if (content instanceof Error && content.message)
    contentString = content.message
  else if (content instanceof Error) contentString = 'Uncaught error.'
  else if (typeof content === 'object' && Array.isArray(content.nonFieldErrors))
    contentString = content.nonFieldErrors.join(' / ')
  else contentString = JSON.stringify(content)

  const currentToasts = passState.toasts

  passState.setToasts ([
    ...currentToasts,
    {
      text: contentString,
      title: title,
      body: null,
      type: type,
      id: uniqueId('toast_'),
      duration,
    },
  ])
}

const createCustomToast = (
  component: ToastComponentType,
  type: ToastOptionType = 'error',
) => {
  const currentToasts = passState.toasts

  passState.setToasts( [
    ...currentToasts,
    {
      type: type,
      body: component,
      id: uniqueId('toast_'),
      text: null,
      title: null,
    },
  ])
}

const deleteToast = (id: string) => {
  const currentToasts = passState.toasts
  passState.setToasts(currentToasts.filter((toast) => toast.id !== id))
}

export const ToastService = {
  create,
  createCustomToast,
  delete: deleteToast,
}
